import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { fetchAgenciesCommissionsById } from '../../store/order/actions/agencies';
import { useOrdersContext } from '../../store/order/order-context';

export const AgencyCommissionsDetailsInformation: FC = () => {
	const { agencyId } = useParams();
	const { orderContextState: { agenciesCommissionsById, isAgenciesCommissionsByIdLoading }, dispatch } = useOrdersContext();

	useEffect(() => {
		void fetchAgenciesCommissionsById(dispatch, agencyId);
	}, []);

	return (
		<div className="mb-10">
			<Table
				name={TablesNames.partnersCommissionsTableData}
				data={agenciesCommissionsById ? [agenciesCommissionsById] : []}
				isLoading={isAgenciesCommissionsByIdLoading}
			/>
		</div>
	);
};